import * as Sentry from '@sentry/browser';

const environments: { [s: string]: string } = {
  'artists.spotify.com': 'production',
  'artists-staging.spotify.com': 'staging',
};

const sampleRate = 0.1;

export function beforeSend(event: Sentry.Event) {
  // sample non-fatal errors
  if (event.level !== Sentry.Severity.Fatal && Math.random() > sampleRate) {
    return null;
  }

  return event;
}

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://f1d4c54bed3f4619a3c79d081d6d7ced@sentry.io/231405',
    release: process.env.REACT_APP_HASH,
    environment: environments[window.location.hostname],
    beforeSend,
    whitelistUrls: [
      /artists\.spotify\.com/, // production
      /ccra\.scdn\.co/, // cdn
    ],
    ignoreErrors: [/Loading chunk .* failed/, /Loading CSS chunk .* failed/],
  });
}
